import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import { getMBMPointData, postMBMPointData } from "services/ConfigServices";
import { methodData, methodDataWithoutRaw, displayData, monthnameData } from "variables/MBM/lists/pointdata";
import { pointdatapagetext } from "variables/MBM/pointdata";
import { dico } from "variables/lists/dico";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import zipcelx from 'zipcelx';
import MenuIcon from "@mui/icons-material/Menu";
import { Menu, MenuItem } from "@mui/material";
import 'moment/locale/fr';
import { CSVLink } from "react-csv";
import ChartV2, { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";

const downloadCsvButton = {
  textDecoration: 'none',
  color: 'rgb(0 0 0 / 87%)'
}
const menuItemStyle = {
  fontSize: '1.2rem',
  fontFamily: '"Source Sans Pro",sans-serif',
}
const menuButtonStyle = {
  float: "right",
  position: "relative",
  marginRight: "-0.5rem",
  paddingTop: "9px",
  fontFamily: '"Source Sans Pro",sans-serif',
};
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const Data = styled.div`
font-size: 14px;
font-weight: 600;
opacity: 1;
`;
const DataMargin = styled.div`
font-size: 14px;
font-weight: 500;
opacity: 1;
margin-left: 15px;
`;
const DataResult = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
`;
const DataResultLink = styled.div`
  padding: 0.25rem 0.25rem;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  margin-left: auto;
  text-align: right;
  cursor: pointer;
  text-decoration: underline;
`;
const DataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.1rem 1rem;
`;
const DataList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0.6rem 0;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const HighchartsContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: -30px;
`;

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "63ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;



function ViewPointDataDialog(props) {
  const { closeModal, currentItem, pointdata, planrawdata, plan1ddata, plan1hdata, currentPoint, tree } = props;
  const chartRef = React.useRef(null);
  const [openMenu, setOpenMenu] = React.useState(null);
  const [csvHeaders, setCsvHeaders] = useState([]);
  const [csvLines, setCsvLines] = useState([]);
  const [method, setMethod] = useState("1d");
  const [datebegin, setDatebegin] = useState(moment().subtract(1, 'week').format("YYYY-MM-DD"));
  const [dateend, setDateend] = useState(moment().format("YYYY-MM-DD"));
  const [display, setDisplay] = useState("linechart");
  const [data, setData] = useState([]);
  const [highchartData, setHighchartData] = useState([]);
  const [datesdata, setDatesdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [daterange, setDaterange] = useState("0");
  const [point, setPoint] = useState({});
  const [loaddata, setLoaddata] = useState(false);
  const classes = useStyles();
  const [chart, setChart] = useState("");
  const [resultchart, setResultchart] = useState("");
  const [pointlist, setPointlist] = useState([]);
  const [avobpointlist, setAvobpointlist] = useState([]);

  useEffect(() => {
    //console.log("use effect");
    let charttmp = {};

    charttmp.xaxisscale = "time";
    charttmp.xaxistimetick = "day";
    charttmp.type = "linechart";
    //console.log(currentItem?.parameters?.valuetype);
    if (currentItem && currentItem.parameters?.valuetype === 'point') {
      charttmp.name = currentItem.parameters?.name;

      let pointtmp = pointdata.find((pt) => pt.id == currentItem.parameters?.value);
      if (pointtmp) {
        //console.log(pointtmp);
        charttmp.yaxis1unit = dico.find((x) => x.id == pointtmp.definition)?.unit || "";
        let serie = {};
        serie.name = dico.find((x) => x.id == pointtmp.definition)?.name || "";
        serie.color = "url(#colorGreen)";
        serie.stackId = "Pile 1";
        serie.type = "column";
        charttmp.series = [];
        charttmp.series.push(serie);
        setChart(charttmp);
        setPoint(pointtmp);
        //console.log(currentItem.parameters?.valueagg);
        if (currentItem.parameters?.valueagg) {
          if (currentItem.parameters?.valueagg === 'raw' && planrawdata[pointtmp.id]) {
            setMethod("raw");
            let sorteddata = JSON.parse(JSON.stringify(planrawdata[pointtmp.id]));
            //let sorteddata = [...planrawdata[pointtmp.id]];
            if (currentItem.parameters?.coef) {
              sorteddata.forEach((d) => d.value = Number(currentItem.parameters.coef) * Number(d.value));
            }
            setData(sorteddata);
            createexportdata(sorteddata);
            buildchart(sorteddata, "raw", "linechart", pointtmp);
          }
          else if (currentItem.parameters?.valueagg === 'hour' && plan1hdata[pointtmp.pointid]) {
            setMethod("1h");
            let sorteddata = JSON.parse(JSON.stringify(plan1hdata[pointtmp.pointid]));
            //let sorteddata = [...plan1hdata[pointtmp.pointid]];
            if (currentItem.parameters?.coef) {
              sorteddata.forEach((d) => d.value = Number(currentItem.parameters.coef) * Number(d.value));
            }
            setData(sorteddata);
            createexportdata(sorteddata);
            buildchart(sorteddata, "1h", "linechart", pointtmp);
          }
          else if (currentItem.parameters?.valueagg === 'day' && plan1ddata[pointtmp.pointid]) {
            setMethod("1d");
            let sorteddata = JSON.parse(JSON.stringify(plan1ddata[pointtmp.pointid]));
            //let sorteddata = [...plan1ddata[pointtmp.pointid]];
            if (currentItem.parameters?.coef) {
              sorteddata.forEach((d) => d.value = Number(currentItem.parameters.coef) * Number(d.value));
            }
            setData(sorteddata);
            createexportdata(sorteddata);
            buildchart(sorteddata, "1d", "linechart", pointtmp);
          }
        }
        else {
          setLoaddata(true);
        }
      }
    }
    else if (currentItem && currentItem.parameters?.valuetype === 'agg') {
      //console.log(currentItem);
      let starttree = tree;
      if (currentItem) {
        let startnode = lookForItemInTree(tree);
        //console.log(startnode);
        if (startnode && startnode.children && startnode.children.length > 0)
          starttree = startnode.children;
      }
      if (starttree && starttree.length > 0) {
        let pointlisttmp = [];
        getPointListFromLeaf(starttree, pointlisttmp);
        let avobpointlisttmp = [];
        pointlisttmp.forEach((pt) => {
          let pointtmp = pointdata.find((ptd) => ptd.id == pt.avobitem.parameters.value);
          if (pointtmp)
          {
            avobpointlisttmp.push(pointtmp);
            pt.pointid = pointtmp.pointid;
          }
        })
        if (pointlisttmp.length > 0) {
          setAvobpointlist(avobpointlisttmp);
          setPointlist(pointlisttmp);
          setLoaddata(true);
        }
      }
    }
    else if (currentPoint) {
      //console.log(currentPoint);
      charttmp.name = currentPoint.name;
      charttmp.yaxis1unit = dico.find((x) => x.id == currentPoint.definition)?.unit || "";
      let serie = {};
      serie.name = dico.find((x) => x.id == currentPoint.definition)?.name || "";
      serie.color = "url(#colorGreen)";
      serie.stackId = "Pile 1";
      serie.type = "column";
      charttmp.series = [];
      charttmp.series.push(serie);
      setChart(charttmp);
      setPoint(currentPoint);
      setMethod("1d");
      if (plan1ddata[currentPoint.pointid]) {
        let sorteddata = JSON.parse(JSON.stringify(plan1ddata[currentPoint.pointid]));
        setData(sorteddata);
        createexportdata(sorteddata);
        buildchart(sorteddata, "1d", "linechart", currentPoint);
      }
      else
        setLoaddata(true);
    }

  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      if (display === 'barchart' || display === 'linechart') {
        let vals = data.map((d) => {
          return { time: d.date, value: Number(d.value) }
        })
        let charttmp = { ...chart };
        charttmp.type = display === 'barchart' ? "columnchart" : 'linechart';
        charttmp.xaxistimetick = (method === 'raw' || method === '1h') ? 'hour' : 'day';
        charttmp.series[0].values = vals;
        //setChart(charttmp);
        let resultcharttmp = getChartCategoryScriptV2(charttmp, 1, "", true);
        setResultchart(resultcharttmp);
      }
    }

  }, [display]);

  const buildchart = (data, method, display, point) => {
    if (data && data.length > 0) {
      if (display === 'barchart' || display === 'linechart') {
        let vals = data.map((d) => {
          return { time: d.date, value: Number(d.value) }
        })
        let charttmp = {};
        charttmp.name = currentItem ? currentItem.parameters?.name : currentPoint.name;
        charttmp.yaxis1unit = currentItem ? currentItem.parameters?.unit : "";
        let serie = {};
        serie.name = currentItem ? currentItem.parameters?.name : currentPoint.name;
        serie.color = "url(#colorGreen)";
        serie.stackId = "Pile 1";
        serie.type = "column";
        charttmp.series = [];
        charttmp.series.push(serie);
        charttmp.xaxisscale = "time";
        charttmp.type = display === 'barchart' ? "columnchart" : 'linechart';
        charttmp.xaxistimetick = (method === 'raw' || method === '1h') ? 'hour' : 'day';
        charttmp.series[0].values = vals;
        let resultcharttmp = getChartCategoryScriptV2(charttmp, 1, "", true);
        setResultchart(resultcharttmp);
      }
    }
  }

  const handleMethodChange = (event) => {
    if (method === 'raw') {
      setDatebegin(datesdata.find((obj) => obj.id === "0").datebegin);
      setDateend(datesdata.find((obj) => obj.id === "0").dateend);
      setDaterange("0");
    }
    setMethod(event.target.value);
    setLoaddata(true);
  };
  const handleDisplayChange = (event) => { setDisplay(event.target.value); };
  const handleDaterangeChange = (event) => {
    setDatebegin(datesdata.find((obj) => obj.id === event.target.value).datebegin);
    setDateend(datesdata.find((obj) => obj.id === event.target.value).dateend);
    setDaterange(event.target.value);
    setLoaddata(true);
  };

  useEffect(() => {
    if (point && point.id && loaddata) {
      setLoading(true);
      setLoaddata(false);
      axios
        .get(getMBMPointData(method === 'raw' ? point.id : point.pointid, datebegin, dateend, method), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
        .then((res) => {
          let sorteddata = res.data.sort((a, b) => a.date - b.date);
          sorteddata.forEach((d) => d.value = d.value.replace(",", "."));
          if (currentItem && currentItem.parameters?.coef) {
            sorteddata.forEach((d) => d.value = Number(currentItem.parameters.coef) * Number(d.value));
          }
          setData(sorteddata);
          createexportdata(sorteddata);
          setLoading(false);
          buildchart(sorteddata, method, display, point);
        });
    }
    else if (avobpointlist.length > 0 && loaddata) {
      let pointids = avobpointlist.map((point) => {
        return "" + point.pointid;
      })
      let request = {
        datebegin,
        dateend,
        method,
        pointids,
        app: "" //to delete after maj
      }
      setLoading(true);
      axios
        .post(postMBMPointData(),
          request,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
              'Content-Type': "application/json; charset=utf-8",
            },
          })
        .then((res) => {
          setLoading(false);
          let sorteddata = [];
          pointlist.forEach((point) => {
            if (res.data[point.pointid]) {
              res.data[point.pointid].forEach((resdata) => {
                let datept = sorteddata.find((val) => val.date === resdata.date);
                let val = Number(resdata.value);
                if (point.avobitem.parameters?.coef)
                  val = Number(point.avobitem.parameters.coef) * Number(val);
                if (!datept) {
                  datept = { date: resdata.date, value: val };
                  sorteddata.push(datept);
                }
                else {
                  datept.value = datept.value + val;
                }
              });
            }
          });
          sorteddata = sorteddata.sort((a, b) => a.date - b.date);
          setData(sorteddata);
          createexportdata(sorteddata);
          setLoading(false);
          buildchart(sorteddata, method, display, point);
        });
    }
  }, [loaddata, point, method, datebegin, dateend, avobpointlist, pointlist]);

  const createexportdata = (sorteddata) => {
    let csvlinestmp = [];
    let highdata = [];
    if (sorteddata) {
      highdata = sorteddata.map((item) => {
        let dataobj = [];
        dataobj.push(item.date);
        dataobj.push(Number(item.value));

        let csvline = {};
        csvline.date = moment(item.date).utc().format("DD/MM/YYYY HH:mm");
        csvline.value = Number(item.value);
        csvlinestmp.push(csvline);

        return dataobj;
      });
    }
    setCsvLines(csvlinestmp);
    const headerdate = { label: pointdatapagetext.date, key: 'date' };
    const headerval = { label: pointdatapagetext.value, key: "value" };
    setCsvHeaders([headerdate, headerval]);
    setHighchartData(highdata);
  }

  useEffect(() => {
    let datesdatatmp = [];
    let nowmoment = moment();
    let onemonthmomentw = moment().subtract(1, 'week');
    datesdatatmp.push({ id: "0", name: "1 semaine", datebegin: onemonthmomentw.format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    let onemonthmoment = moment().subtract(1, 'month');
    datesdatatmp.push({ id: "1", name: "1 mois glissant", datebegin: onemonthmoment.format("YYYY-MM-DD"), dateend: nowmoment.format("YYYY-MM-DD") });
    for (let i = 1; i <= 24; i++) {
      let substractedmoment = moment().subtract(i, 'month');
      let month = monthnameData.find((obj) => obj.id === substractedmoment.format("MMMM")).name;
      let year = substractedmoment.format("YYYY");
      let datebeginstr = substractedmoment.set('date', 1).format("YYYY-MM-DD");
      let dateendstr = substractedmoment.add(1, 'month').set('date', 1).subtract(1, 'day').format("YYYY-MM-DD"); //go to the end of month
      datesdatatmp.push({ id: "" + (i + 1), name: month + " " + year, datebegin: datebeginstr, dateend: dateendstr });
    }
    setDatesdata(datesdatatmp);
  }, []);

  const lookForItemInTree = (tree) => {
    let startnode = '';
    tree.forEach((node) => {
      if (!startnode) {
        if (currentItem && node.id === "" + currentItem.id) {
          startnode = node;
        }
        else if (node.children && node.children.length > 0)
          startnode = lookForItemInTree(node.children)
      }
    });
    return startnode;
  }

  const getPointListFromLeaf = (tree, pointlist) => {
    tree.forEach((node) => {
      if (node.avobitem?.parameters?.valuetype === 'agg' && node.children && node.children.length > 0)
        getPointListFromLeaf(node.children, pointlist);
      else {
        if (node.avobitem?.parameters?.valuetype === 'point' && node.avobitem?.parameters?.value) {
          pointlist.push(node);
        }
      }
    });
  }

  const getData = (avobpointlisttmp) => {

  }

  const columns = [
    {
      name: pointdatapagetext.date,
      selector: (row) => row.date,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.date && moment(row.date).isValid()
          ? moment(row.date).utc().format("DD/MM/YYYY HH:mm")
          : "",
    },
    {
      name: pointdatapagetext.value,
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.value ? (new Intl.NumberFormat('fr-FR').format(row.value.replace(",", ".")) + " " + (dico.find((x) => x.id == point.definition)?.unit || "")) : ""
    },
  ]

  const optionsColumnChart = {
    chart: {
      zoomType: "x",
      type: "column",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  const optionsLineChart = {
    chart: {
      zoomType: "x",
      type: "line",
      height: "350px",
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "datetime",
    },
    yAxis: [
      {
        title: {
          text: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
    legend: {
      shadow: false,
      //enabled: false
    },
    tooltip: {
      shared: true,
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: dico.find((x) => x.id == point.definition)?.name || "",
        // color: colorRef,
        data: highchartData || [],
        tooltip: {
          valueSuffix: dico.find((x) => x.id == point.definition)?.unit || "",
        },
      },
    ],
  };

  const handleClick = (event) => {
    setOpenMenu(event.currentTarget);
  };

  const handleClose = () => {
    setOpenMenu(null);
  };

  const downloadPng = () => {
    const chartToExport = display === 'barchart' ? optionsColumnChart : display === 'linechart' ? optionsLineChart : "";
    chartToExport.title.text = "";
    chartRef.current.chart.exportChart({
      type: "image/png",
      filename: "export",
    }, chartToExport);
    chartToExport.title.text = "";
    handleClose();
  };

  const downloadCsv = () => {
    chartRef.current.chart.downloadCSV();
    handleClose();
  };

  const downloadXlsx = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;
    div.style.display = 'none';
    document.body.appendChild(div);
    rows = chartRef.current.chart.getDataRows(true);
    var datetime = false;
    if (rows.length > 0) {
      if (rows[0][0] === 'DateTime') {
        datetime = true;
      }
    }
    xlsxRows = rows.slice(1).map((row, rowindex) => {
      return row.map((column, index) => {
        if (rowindex > 0 && index === 0 && datetime) {
          column = moment(column).format("DD/MM/YYYY HH:mm");
        }
        return {
          type: typeof column === 'number' ? 'number' : 'string',
          value: column
        };
      });
    });
    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };
  const downloadXlsxTab = () => {
    var div = document.createElement('div'),
      name,
      xlsxRows = [],
      rows;

    const headerdate = { value: pointdatapagetext.date, type: 'string' };
    const headerval = { value: pointdatapagetext.value, type: "string" };
    var headers = [headerdate, headerval]


    xlsxRows = data.map((row, rowindex) => {
      let xlsxrow = [{ type: 'string', value: moment(row.date).utc().format("DD/MM/YYYY HH:mm") }, { type: 'string', value: row.value ? new Intl.NumberFormat('fr-FR').format(row.value) : "" }];
      return xlsxrow
    });

    xlsxRows.unshift(headers);

    zipcelx({
      filename: "export",
      sheet: {
        data: xlsxRows
      }
    });
    handleClose();
  };

  return (
    <>
      <form className={classes.root}>
        {point &&
          <GridContainer>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.method}
                  selectValue={method}
                  handleSelectValueChange={handleMethodChange}
                  data={(currentItem && currentItem.parameters?.valuetype === 'agg') ? methodDataWithoutRaw : methodData}
                  disabled={loading}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.daterange}
                  selectValue={daterange}
                  handleSelectValueChange={handleDaterangeChange}
                  data={datesdata}
                  disabled={loading}
                />
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <div>
                <CustomSelect
                  inputTitle={pointdatapagetext.display}
                  selectValue={display}
                  handleSelectValueChange={handleDisplayChange}
                  data={displayData}
                  disabled={loading}
                />
              </div>
            </GridItem>
            {
              loading ?
                <GridItem xs={12} sm={12} md={12} lg={12}><div style={{ paddingTop: "12px", marginLeft: "35%" }}>Récupération des données en cours...</div></GridItem>
                :
                <GridItem xs={12} sm={12} md={12} lg={12}>
                  {display === 'tab' ?
                    <Container>
                      <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="simple-menu"
                          className={"menu-chart"}
                          anchorEl={openMenu}
                          keepMounted
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                          style={menuItemStyle}
                        >
                          <MenuItem onClick={downloadXlsxTab} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem key={Math.random()}>
                            <CSVLink
                              className={'csv'} data={csvLines}
                              headers={csvHeaders} style={downloadCsvButton}
                              filename={`export.csv`} target="_blank"
                              separator={";"}
                            >
                              Télécharger en CSV
                            </CSVLink>
                          </MenuItem>
                        </Menu>
                      </div>
                      <DataTable
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                        dense
                        noDataComponent={<NoData>{pointdatapagetext.nodata}</NoData>}
                        noHeader={true}
                        columns={columns}
                        persistTableHead
                        pagination
                        data={data}
                        paginationComponentOptions={{
                          noRowsPerPage: false,
                          rowsPerPageText: "Lignes par page",
                          rangeSeparatorText: "sur",
                          selectAllRowsItem: false,
                          selectAllRowsItemText: "Selectionner toutes les lignes",
                        }}
                      />
                    </Container>
                    :
                    <>
                      {/* <div>
                        <Button
                          aria-controls="chart-menu"
                          aria-haspopup="true"
                          onClick={handleClick}
                          justicon={"true"}
                          style={menuButtonStyle}
                        >
                          <MenuIcon />
                        </Button>
                        <Menu
                          id="chart-menu"
                          className={"chart-menu"}
                          anchorEl={openMenu}
                          keepMounted
                          aria-haspopup={'menu'}
                          open={Boolean(openMenu)}
                          onClose={handleClose}
                        >
                          <MenuItem onClick={downloadPng} key={`downPng_${Math.random()}`}>
                            Télécharger en PNG
                          </MenuItem>
                          <MenuItem onClick={downloadXlsx} key={`downCsv${Math.random()}`}>
                            Télécharger en XLSX
                          </MenuItem>
                          <MenuItem onClick={downloadCsv} key={`downCsv${Math.random()}`}>
                            Télécharger en CSV
                          </MenuItem>
                        </Menu>
                      </div>
                     {display === 'barchart' &&
                        <HighchartsContainer>
                          <HighchartsReact highcharts={Highcharts} options={optionsColumnChart} ref={chartRef} />
                        </HighchartsContainer>
                      }
                      {display === 'linechart' &&
                        <HighchartsContainer>
                          <HighchartsReact highcharts={Highcharts} options={optionsLineChart} ref={chartRef} />
                        </HighchartsContainer>
                      } */}

                      {((display === 'barchart' || display === 'linechart') && resultchart && data && data.length > 0) ?
                        <HighchartsContainer>
                          {resultchart}
                        </HighchartsContainer>
                        : <></>
                      }
                    </>
                  }
                </GridItem>
            }
          </GridContainer>}
      </form>
    </>
  );
}

export default ViewPointDataDialog;
